import React, {useCallback, useEffect, useState} from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../filters/TimeFilter';
import {
  Button, Checkbox,
  Divider,
  ListItem,
  ListItemAvatar,
  Stack,
  Typography,
} from '@mui/material';
import List from '@mui/material/List';
import api from '../../../services/api';
import { FileUploader } from 'react-drag-drop-files';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import Tooltip from '@mui/material/Tooltip';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import {MoreFileOptions} from "../assets/MoreFileOptions";
import {toaster} from "../../../services/toaster";
import toast from "react-hot-toast";
import {file} from "../../../schema/file";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {downloadAttachment} from "../../../utils/downloadAttachment";

export const FileField: FieldComponent<any, any> = ({
  onChange,
  isActive,
  value,
  allValue,
  hasTooltip,
  disabled,
  mui,
  column,
  schema,
  mainSchema,
  columnName,
  addingNewEntity,
  tab,
}) => {
  const [manualConfirmations, setManualConformations] = React.useState<any>([]);
  const [files, setFiles] = useState<any>([]);
  const [softLoading, setSoftLoading] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);

  const fetchManualConfirmations = async () => {
    const searchParams = new URLSearchParams({});

    const url = (columnName === 'confirms' || column?.columnName === 'confirms') ? 'accommodation-reservation-files' : 'service-reservation-files';

    api
      .get(`/${url}/${allValue?.id}`, searchParams)
      .then((result: any) => {
        setManualConformations(result);
      });
  };

  useEffect(() => {
    fetchManualConfirmations();
  }, []);

  const handleChange = (newFiles: any) => {
    const newFilesArray = [...newFiles];
    const oldFiles = [...files];
    newFilesArray.map((file: any) => {
      file.preview = URL.createObjectURL(file);
      oldFiles.push(file);
    });

    uploadFiles(newFilesArray);

    if (addingNewEntity) {
      onChange(oldFiles);
    }
  };
  const uploadFiles = (files: any) => {
    setSoftLoading(true);

    // Create a form and post it to server
    let formData = new FormData();
    files.forEach((file: any, i: any) => {
      formData.append(`file-${i}`, file);
    });

    formData.append(`column`, (column?.columnName || columnName));
    formData.append(`id`, allValue?.id);
    formData.append(`schema`, JSON.stringify(schema || mainSchema));

    api
      .postFile(`/upload-files`, formData)
      .then((res: any) => {
        const mC = [...manualConfirmations];
        res.map((item: any) => {
          mC.push(item);
        });
        setManualConformations(mC);
      })
      .catch((error: any) => {})
      .finally(()=>{
        setSoftLoading(false);
      });
  };

  const handleChangeCheckBox = (event: any, index: any, columnName: string) => {

    const newFiles = [...manualConfirmations];
    newFiles.map((row: any, rowIndex: number) => {
      if (index === rowIndex) {
        row[columnName] = event.target.checked;



      }
      newFiles[rowIndex] = row;
    });

    setManualConformations(newFiles);
  };

  const handleDownload = async (attachment: any) => {
    try {
      await downloadAttachment(attachment, api.getFile);
    } catch (error) {
      console.log(error);
      toaster.show({
        icon: 'error',
        message: `Error while download data`,
        intent: 'danger',
      });
    }
    return true;
  };

  const handleUpdateImage = useCallback(
    async (image: any, data: any) => {
      file.client
        .update(image?.id, data)
        .then((res: any) => {
          const oldProperties = [...manualConfirmations];
          const newRows = oldProperties.map((row: any) => {
            return row.id === image.id ? res : row;
          });
          setManualConformations(newRows);
        })
        .catch((e: any) => {
          console.error(e);
        });
    },
    [manualConfirmations]
  );



  return (
    <>
      <Stack
        sx={{
          opacity: softLoading ? 0.5 : 1,
          pointerEvents: softLoading ? 'none' : 'auto',
        }}
      >
        <FileUploader
          multiple={true}
          handleChange={handleChange}
          name="file"
          classes={'w-full !max-w-[100%] !min-w-[100px]'}
        />
      </Stack>
      <Divider />
      <List
        component="div"
        aria-labelledby="Files"
        sx={{
          opacity: softLoading ? 0.5 : 1,
          pointerEvents: softLoading ? 'none' : 'auto',
          width: '100%',
        }}
      >
        {manualConfirmations.map((item: any, index: number) => {
          return (
              <>
                <ListItem
                  sx={{
                    borderBottom: '1px solid #f3f3f3',
                    padding: '8px',
                  }}
                  key={`list-images-${index}`}
                  id={`list-images-${index}`}
                >
                  <ListItemAvatar
                    sx={{
                      '& .MuiAvatar-root': {
                        border: '1px solid #e1e1e1',
                        borderRadius: '4px',
                        width: '50px',
                        height: '50px',
                      },
                    }}
                  >
                    {item?.type.includes('image') ? (
                      <Zoom>
                        <Tooltip title={item?.name}>
                          <Avatar src={item?.link} alt={item?.name} />
                        </Tooltip>
                      </Zoom>
                    ) : (
                      <div
                        className={
                          'w-[50px] h-[50px] rounded-[4px] bg-[#e1e1e1] relative'
                        }
                      >
                        <FolderRoundedIcon
                          sx={{
                            color: '#b9b9b9',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%,-50%)',
                          }}
                        />
                      </div>
                    )}
                  </ListItemAvatar>
                  <ListItemText
                    secondary={
                      <React.Fragment>
                        <Tooltip title={item?.name}>
                          <Typography
                            variant={'caption'}
                            color={'gray'}
                            sx={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: 'block'
                            }}
                          >
                            {item?.name}
                          </Typography>
                        </Tooltip>
                      </React.Fragment>
                    }
                  />
                  <Stack
                    direction={'row'}
                    sx={{
                      width: '100px',
                    }}
                  >
                    <Tooltip title="Visible to Guide">
                      <Checkbox
                        checked={
                          item?.guide_visible
                            ? item.guide_visible
                            : false
                        }
                        inputProps={{ 'aria-label': 'Checkbox demo' }}
                        icon={<VisibilityOffOutlinedIcon />}
                        checkedIcon={
                          <VisibilityOutlinedIcon color={'primary'} />
                        }
                        onChange={(event) => {
                         /* handleChangeCheckBox(
                            event,
                            index,
                            'guide_visible'
                          );*/
                          handleUpdateImage(item, {
                            guide_visible: event.target.checked,
                          });
                        }}
                      />
                    </Tooltip>

                    <MoreFileOptions
                      hideEdit={true}
                      clickOnEdit={() => {

                      }}
                      clickOnDelete={() => {
                        setOpenConfirmDialog({
                          row: item,
                          schema: file,
                        });
                      }}
                      clickOnDownload={() => {
                        handleDownload(item);
                      }}
                    />
                  </Stack>
                </ListItem>
              </>
          );
        })}
      </List>

      {openConfirmDialog && (
        <Dialog
          open={openConfirmDialog}
          onClose={() => {
            setOpenConfirmDialog(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {'Are you sure you want to delete it?'}
          </DialogTitle>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfirmDialog(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant={'contained'}
              color={'error'}
              onClick={() => {
                const deletedRow = openConfirmDialog?.row;

                openConfirmDialog?.schema.client
                  .delete(deletedRow.id as number, { id: deletedRow.id })
                  .then((res: any) => {
                    toast.success(`Successfully deleted ${schema.name}: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`);
                    setOpenConfirmDialog(false);

                    fetchManualConfirmations();

                  })
                  .catch((e: any) => {
                    toast.error(`Error: Unable to delete Image: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`);
                  });
              }}
              autoFocus
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}


    </>
  );
};

FileField.includes = (query, value) => true;

FileField.comparator = () => 0;

FileField.FilterRenderer = TimeFilter;
